import '../css/Footer.css';

const Footer = () => {
  return (
    <footer className='footer'>
      <div className='footer-container footer-text-size'>
        <h1>Contact Me</h1>
        <p>Christopher Estevez</p>
        <a className='footer-email' href='malito:cestevez1014@gmail.com'>
          cestevez1014@gmail.com
        </a>
        <p>&copy; 2022 Christopher E</p>
      </div>
    </footer>
  );
};

export default Footer;
